import { render } from "./wf-pl35.vue?vue&type=template&id=520767f7&scoped=true"
import script from "./wf-pl35.vue?vue&type=script&lang=js"
export * from "./wf-pl35.vue?vue&type=script&lang=js"

import "./wf-pl35.vue?vue&type=style&index=0&id=520767f7&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520767f7"]])

export default __exports__